class Monitoring.Models.Survey

  @keywordDefaults:
    primary_keywords: []
    secondary_keywords: []
    excluded_keywords: []
    primary_keywords_logic: 'OR'
    secondary_keywords_logic: 'OR'
    excluded_keywords_logic: 'OR'
    name: undefined

  constructor: (id, name, items = {}, keywords = {}) ->
    @id = parseInt(id)
    @name = name
    @items = items
    @keywords = keywords

  addItem: (code, value, alias) =>
    @items[code] ||= { name: alias, values: [] }
    if (@items[code].values.indexOf(value)) == -1
      @items[code].values.push(value)

  removeItem: (code, value) =>
    if (index = @items[code].values.indexOf(value)) != -1
      @items[code].values.splice(index, 1);
    if @items[code].values.length == 0
      @items[code] = undefined

  getKeyword: (code, attribute) =>
    if @keywords[code]
      return @keywords[code][attribute]
    return Monitoring.Models.Survey.keywordDefaults[attribute]

  setKeyword: (code, attribute, value) =>
    @keywords[code] ||= {}
    @keywords[code][attribute] = value

  removeKeyword: (code, attribute, value) =>
    if (index = @keywords[code][attribute].indexOf(value)) != -1
      @keywords[code][attribute].splice(index, 1);

  resetKeywords: (code) =>
    @keywords[code] = {}

  @toJSON: (s) =>
    return {id: s.id, name: s.name, items: s.items, keywords: s.keywords}


class Monitoring.Models.SurveyCollection

  constructor: (list) ->
    @list = _.map(list, (s) => new Monitoring.Models.Survey(s.id, s.name, s.items, s.keywords))

  findOrCreate: (name, id) =>
    survey = _.find(@list, (s) => parseInt(s.id) == parseInt(id) )
    return survey if survey
    survey = new Monitoring.Models.Survey(id, name)
    @list.push(survey)
    return survey

  findById: (id) =>
    return _.find(@list, (s) => parseInt(s.id) == parseInt(id))

  toJSON: () =>
    return _.map(@list, (s) => Monitoring.Models.Survey.toJSON(s))
